module.exports = __webpack_public_path__ + "static/img/fn6.058183e0.png";